import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-3 row pt-0" }
const _hoisted_2 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-3" }
const _hoisted_3 = { class: "col p-0" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_7 = { class: "col p-0" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_10 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_14 = { class: "form-group mb-2 col" }
const _hoisted_15 = { class: "col-auto p-0 text-end" }
const _hoisted_16 = {
  key: 0,
  class: "p-3 pt-0"
}
const _hoisted_17 = { class: "overflow-auto" }
const _hoisted_18 = { class: "table table-striped border-light align-middle text-left position-relative" }
const _hoisted_19 = { class: "text-capitalize-first" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-capitalize-first" }
const _hoisted_22 = { class: "d-flex flex-column mt-1 mb-1" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "text-secondary" }
const _hoisted_25 = { class: "text-secondary" }
const _hoisted_26 = { class: "text-secondary" }
const _hoisted_27 = { class: "text-secondary" }
const _hoisted_28 = {
  class: "align-top",
  style: {"max-width":"500px"}
}
const _hoisted_29 = { style: {"white-space":"pre-line"} }
const _hoisted_30 = {
  class: "align-top",
  style: {"max-width":"500px"}
}
const _hoisted_31 = { style: {"white-space":"pre-line"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.$t('labels.provider_request_log'),
    "dialog-class": "modal-xxl",
    modelValue: _ctx.providerId !== null,
    "footer-class": "d-flex justify-content-end",
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ($event === false && (_ctx.providerId = null)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        class: "h-100"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control form-control-sm",
                    placeholder: _ctx.helper.trans('labels.id'),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.invoiceId) = $event))
                  }, null, 8, _hoisted_5), [
                    [_vModelText, _ctx.filters.invoiceId]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.filters.fromDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.fromDate) = $event)),
                    mode: "dateTime",
                    "model-modifiers": {string: true},
                    is24hr: "",
                    masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.from_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_9)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.filters.toDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.toDate) = $event)),
                    mode: "dateTime",
                    "model-modifiers": {string: true},
                    is24hr: "",
                    masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                  }, {
                    default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        placeholder: _ctx.helper.trans('labels.to_date'),
                        value: inputValue,
                        onFocus: togglePopover,
                        onChange: inputEvents.change
                      }, null, 40, _hoisted_13)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(() => _ctx.applyFilters(), ["prevent"])),
                  class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                }, _toDisplayString(_ctx.helper.trans('button.apply')), 1)
              ])
            ])
          ]),
          (_ctx.providerId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('labels.id_date')), 1),
                        _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('labels.request')), 1),
                        _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('labels.response')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedResponse.items, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: ""
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("span", null, [
                                _withDirectives((_openBlock(), _createElementBlock("span", {
                                  title: item.invoiceId
                                }, [
                                  _createTextVNode(_toDisplayString(item.invoiceId.substring(0, 8)) + "...", 1)
                                ], 8, _hoisted_23)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ]),
                                _cache[8] || (_cache[8] = _createTextVNode()),
                                _createVNode(_component_copy_button, {
                                  value: item.invoiceId
                                }, null, 8, ["value"])
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("small", _hoisted_24, _toDisplayString(_ctx.dateHelper.format(item.requestAt, 'YYYY-MM-DD')), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("small", _hoisted_25, _toDisplayString(_ctx.dateHelper.format(item.requestAt, 'HH:mm:ss.SSS')), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.dateHelper.format(item.responseAt, 'HH:mm:ss.SSS')), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("small", _hoisted_27, _toDisplayString(_ctx.numberFormatter.formatNumber(item.duration, 3)) + "s", 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_28, [
                            _createElementVNode("pre", null, [
                              _createElementVNode("code", _hoisted_29, "\n                      " + _toDisplayString(item.method) + " " + _toDisplayString(item.uri) + "\n\n                      BODY\n                      " + _toDisplayString(item.body) + "\n\n                      HEADERS\n                      " + _toDisplayString(JSON.stringify(item.headers)) + "\n                    ", 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_30, [
                            _createElementVNode("pre", null, [
                              _createElementVNode("code", _hoisted_31, "\n                    CODE: " + _toDisplayString(item.responseCode) + "\n\n                    BODY\n                    " + _toDisplayString(item.response) + "\n                    ", 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.paginatedResponse.totalCount > _ctx.paginatedResponse.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[5] || (_cache[5] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.paginatedResponse.totalCount,
                        "per-page": _ctx.paginatedResponse.limit,
                        limit: 20,
                        "prev-text": _ctx.helper.trans('button.back'),
                        "next-text": _ctx.helper.trans('button.next'),
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.providerId = null), ["prevent"])),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}